<h2 mat-dialog-title style="text-align: center">
  Zu einem Dokument zusammenfügen
</h2>
<mat-dialog-content class="mat-typography">
  <div style="width: 100%; height: 100%; position: relative">
    <div class="row-layout" style="padding: 8px; align-items: center;">
      <div style="padding: 0 16px">
        <mat-checkbox
          [checked]="allSelected"
          (change)="selectAllDocuments($event)"
        ></mat-checkbox>
      </div>
      <div style="font-size: 1.25rem">Dateien</div>
    </div>

    <div
      style="
        max-height: 40vh;
        overflow: auto;
        padding: 8px;
        border: 1px solid grey;
        border-radius: 4px;
        margin-top: 8px;
      "
    >
      <div
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        class="merge-dialog-list"
      >
        <div
          *ngFor="let f of files; let $idx = index"
          cdkDrag
          (cdkDragMoved)="dragMoved($event)"
        >
          <div class="merge-file-placeholder" *cdkDragPlaceholder></div>
          <div
            class="row-layout merge-dialog-list-item merge-dialog-list-content"
            [ngClass]="{
              'line-grey-bg': $idx % 2 === 0,
              'white-bg': $idx % 2 === 1
            }"
          >
            <div
              style="padding: 0 16px"
              [ngClass]="{
                'not-visible-item': !f.canmerge
              }"
            >
              <mat-checkbox
                [checked]="f.merge"
                [disabled]="!f.canmerge"
                (change)="selectDocument($event, f)"
              ></mat-checkbox>
            </div>
            <div>
              {{ f.name }}
              <ng-container *ngIf="!f.canmerge">
                <div style="color: red">Wird nicht hinzugefügt.
                <span *ngIf="!f.exists_server">Datei auf dem Server nicht gefunden.</span></div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row-layout" style="justify-content: stretch; margin-top: 16px">
      <div style="flex: 1">
        <app-input
          label="Dokumentname"
          [(value)]="fileName"
          suffix=".pdf"
        ></app-input>
      </div>
    </div>
    <div *ngIf="isMerging"
    style="
      position: absolute;
      top:0;
      left:0;
      background-color: rgba(128,128,128,0.4);
      z-index: 100;
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    "
  >
    <div class="secondary-color"
    style="z-index: 102;">
      <app-document-progress-bar
        [text]="'Dokumente werden zusammengefügt ...'"
      ></app-document-progress-bar>
    </div>
  </div>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="row-layout flex-content-end"
style="justify-content: flex-end; padding-bottom: 1rem; padding-right: 1rem;">
  <button mat-raised-button (click)="close()" style="margin-right: 2rem">Abbrechen</button>
  <button
    mat-raised-button
    (click)="save()"
    [disabled]="isMerging"
  >
    Speichern
  </button>
</div>
